import { Routes } from '@angular/router';
import {
  AdminLoginComponent,
  AdminResetPasswordRequestFormComponent,
  AdminSetNewPasswordFormComponent,
} from '@buspro/web/admin/auth';
import { TenantDetailsResolver } from '@buspro/web/admin/core';
import { DashboardComponent } from '@buspro/web/admin/dashboard';
import { AdminOnboardingRoutes } from '@buspro/web/admin/onboarding';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AdminWorkspaceLayoutComponent, PageNotFoundComponent } from '@buspro/web/admin/shared';
import { TenantsComponent } from '@buspro/web/admin/tenants/directory';
import { TenantsLayoutComponent } from '@buspro/web/admin/tenants/shared';
import { AnonUserGuard, AuthUserGuard } from '@corelabs/ng-auth';
export const routes: Routes = [
  {
    path: 'passport/login',
    canActivate: [AnonUserGuard],
    component: AdminLoginComponent,
    data: { title: 'Login', preload: true },
  },
  {
    path: 'passport/reset-password-request-form',
    canActivate: [AnonUserGuard],
    data: { title: 'Reset Password' },
    component: AdminResetPasswordRequestFormComponent,
  },
  {
    path: 'passport/password-changed',
    canActivate: [AnonUserGuard],
    component: AdminSetNewPasswordFormComponent,
    data: { title: 'Password changed' },
  },
  AdminOnboardingRoutes,
  {
    path: 'tenants',
    canActivate: [AuthUserGuard],
    // canActivateChild: [AuthUserGuard],
    component: AdminWorkspaceLayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'directory',
      },
      {
        path: 'directory',
        component: TenantsComponent,
        data: { title: 'Tenants Directory' },
      },
      {
        path: 'context/:tid',
        component: TenantsLayoutComponent,
        resolve: { tenant: TenantDetailsResolver },
        children: [
          {
            path: 'overview',
            loadComponent: () => import('@buspro/web/admin/tenants/dashboard').then((c) => c.TenantOverviewComponent),
            data: { title: 'Overview' },
          },
          {
            path: 'dashboard',
            loadComponent: () => import('@buspro/web/tenants/dashboard').then((c) => c.TenantDashboardComponent),
            data: { title: 'Dashboard', preload: true },
          },
          {
            path: 'monitor',
            loadChildren: () => import('@buspro/web/tenants/monitor').then((m) => m.MonitorModule),
            data: { title: 'Monitor' },
          },
          {
            path: 'schedules',
            loadChildren: () => import('@buspro/web/tenants/operations').then((m) => m.OperationsModule),
            data: { title: 'Schedules' },
          },
          {
            path: 'bookings',
            loadChildren: () => import('@buspro/web/tenants/bookings').then((m) => m.BookingModule),
            data: { title: 'Bookings' },
          },
          {
            path: 'reports',
            loadChildren: () => import('@buspro/web/tenants/reports').then((m) => m.ReportsModule),
            data: { title: 'Reports' },
          },
          {
            path: 'sims',
            loadChildren: () => import('@buspro/web/tenants/buses').then((m) => m.SimModule),
            data: { title: 'SIMS' },
          },

          {
            path: 'devices',
            loadChildren: () => import('@buspro/web/tenants/buses').then((m) => m.DeviceModule),
            data: { title: 'Devices' },
          },
          {
            path: 'drivers',
            loadChildren: () => import('@buspro/web/tenants/drivers').then((m) => m.DriversModule),
            data: { title: 'Drivers' },
          },
          {
            path: 'conductors',
            loadChildren: () => import('@buspro/web/tenants/conductors').then((m) => m.ConductorsModule),
            data: { title: 'Conductors' },
          },
          {
            // Mounted because a conductor's page links into it ("View cash").
            // The tenant app has had it since Phase E; without it here the link
            // is dead in the admin app, which lazy-loads the SAME conductor
            // page — the module-sharing trap.
            path: 'cash',
            loadChildren: () => import('@buspro/web/tenants/cash').then((m) => m.CashModule),
            data: { title: 'Cash' },
          },
          {
            path: 'routes',
            loadChildren: () => import('@buspro/web/tenants/routes').then((m) => m.RoutesModule),
            data: { title: 'Routes' },
          },
          {
            path: 'bus-stops',
            loadChildren: () => import('@buspro/web/tenants/places').then((m) => m.BusStopsModule),
            data: { title: 'Bus Stops' },
          },
          {
            path: 'terminals',
            loadChildren: () => import('@buspro/web/tenants/places').then((m) => m.TerminalsModule),
            data: { title: 'Terminals' },
          },

          {
            path: 'buses',
            loadChildren: () => import('@buspro/web/tenants/buses').then((m) => m.BusesModule),
            data: { title: 'Buses' },
          },
          {
            path: 'parcels',
            loadChildren: () => import('@buspro/web/tenants/parcels').then((m) => m.ParcelsModule),
            data: { title: 'Parcels' },
          },
          {
            path: 'operations',
            loadChildren: () => import('@buspro/web/tenants/operations').then((m) => m.OperationsModule),
            data: { title: 'Operations' },
          },
          {
            path: 'monitor',
            loadChildren: () => import('@buspro/web/tenants/monitor').then((m) => m.MonitorModule),
            data: { title: 'Monitor' },
          },
          {
            path: 'users',
            loadChildren: () => import('@buspro/web/tenants/users').then((m) => m.TenantUsersModule),
            data: { title: 'Users' },
          },
          {
            path: 'provisioned-resources',
            loadComponent: () =>
              import('@buspro/web/admin/tenants/shared').then((c) => c.TenantProvisionedResourcesPageComponent),
            data: { title: 'Provisioned Resources' },
          },
        ],
      },
      {
        path: '**',
        component: PageNotFoundComponent,
        data: { title: '404' },
      },
    ],
  },

  {
    path: '',
    canActivate: [AuthUserGuard],
    // canActivateChild: [AuthUserGuard],
    component: AdminWorkspaceLayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        data: { title: 'Main Dashboard', preload: true },
      },
      {
        path: 'bus-stop-dashboard',
        loadComponent: () => import('@buspro/web/admin/dashboard').then((m) => m.BusStopDashboardComponent),
        data: { title: 'Bus Stop Dashboard', preload: true },
      },
      {
        path: 'auditors-dashboard',
        loadComponent: () => import('@buspro/web/admin/dashboard').then((m) => m.AuditorsDashboardComponent),
        data: { title: 'Auditors Dashboard', preload: true },
      },
      {
        path: 'technicians-dashboard',
        loadComponent: () => import('@buspro/web/admin/dashboard').then((m) => m.TechniciansDashboardComponent),
        data: { title: 'Technicians Dashboard', preload: true },
      },
      {
        path: 'sync-watch',
        loadComponent: () => import('@buspro/web/admin/dashboard').then((m) => m.SyncWatchPageComponent),
        data: { title: 'Sync Watch' },
      },
      {
        path: 'notifications',
        loadComponent: () => import('@buspro/web/admin/shared').then((c) => c.AdminNotificationCenterComponent),
        data: { title: 'Notifications' },
      },
      {
        path: 'profile',
        loadComponent: () => import('@buspro/web/admin/shared').then((c) => c.AdminProfilePageComponent),
        data: { title: 'My Profile' },
      },
      {
        path: 'standard-places',
        loadChildren: () => import('@buspro/web/admin/standard-places').then((m) => m.StandardPlacesModule),
        data: { title: 'Official Places' },
      },
      {
        path: 'bus-types',
        loadChildren: () => import('@buspro/web/admin/bus-types').then((m) => m.BusTypesModule),
        data: { title: 'Bus Types' },
      },
      {
        path: 'inventory',
        loadChildren: () => import('@buspro/web/admin/inventory').then((m) => m.AdminInventoryRoutes),
        data: { title: 'Inventory Management' },
      },
      {
        path: 'bus-stops',
        loadChildren: () => import('@buspro/web/admin/bus-stops').then((m) => m.BusStopsRoutes),
        data: { title: 'Bus Stop Management' },
      },
      {
        path: 'locals/users',
        data: { title: 'Manage Local Users' },
        loadComponent: () => import('@buspro/web/admin/users').then((lib) => lib.ManageLocalUsersComponent),
      },
      {
        path: 'app-distribution',
        data: { title: 'App Distribution Testers' },
        loadComponent: () => import('@buspro/web/admin/app-distribution').then((c) => c.AppDistributionPageComponent),
      },
      {
        path: 'audits',
        children: [
          {
            path: '',
            redirectTo: 'ready',
            pathMatch: 'full',
          },
          {
            path: 'ready',
            loadComponent: () => import('@buspro/web/admin/shared').then((c) => c.OperationsReadyForAuditPageComponent),
            data: { title: 'Operations Ready for Audit' },
          },
          {
            path: 'my-audits',
            loadComponent: () => import('@buspro/web/admin/shared').then((c) => c.MyAuditsPageComponent),
            data: { title: 'My Audits' },
          },
          {
            path: 'reports',
            loadComponent: () => import('@buspro/web/admin/shared').then((c) => c.AuditReportsPageComponent),
            data: { title: 'Audit Reports' },
          },
          {
            path: ':operationId/detail',
            loadComponent: () => import('@buspro/web/admin/shared').then((c) => c.AuditDetailPageComponent),
            data: { title: 'Audit Detail' },
          },
          {
            path: ':operationId/report',
            loadComponent: () => import('@buspro/web/admin/shared').then((c) => c.TripAuditReportPageComponent),
            data: { title: 'Trip Audit Report' },
          },
        ],
      },
      { path: '**', component: PageNotFoundComponent },
    ],
  },

  { path: '**', component: PageNotFoundComponent },
];
